import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var FontSizeIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3712 6.6337C39.9397 6.6337 40.4005 7.09467 40.4005 7.66332V40.3367C40.4005 40.9053 39.9397 41.3663 39.3712 41.3663C38.8027 41.3663 38.3419 40.9053 38.3419 40.3367V7.66332C38.3419 7.09467 38.8027 6.6337 39.3712 6.6337Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0576 34.8449C33.4596 34.4428 34.1113 34.4428 34.5133 34.8449L39.3721 39.7052L44.2437 34.844C44.6462 34.4424 45.2979 34.4432 45.6994 34.8458C46.1009 35.2484 46.1001 35.9003 45.6976 36.3019L40.0982 41.8893C39.696 42.2906 39.045 42.2902 38.6434 41.8884L33.0576 36.301C32.6557 35.8989 32.6557 35.247 33.0576 34.8449Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6434 6.11157C39.045 5.70982 39.696 5.70942 40.0982 6.11067L45.6976 11.6981C46.1001 12.0997 46.1009 12.7516 45.6994 13.1542C45.2979 13.5568 44.6462 13.5576 44.2437 13.156L39.3721 8.29483L34.5133 13.1551C34.1113 13.5572 33.4596 13.5572 33.0576 13.1551C32.6557 12.753 32.6557 12.1011 33.0576 11.699L38.6434 6.11157Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9029 5.94728C16.3309 5.94728 16.7142 6.21221 16.8656 6.61266L29.7389 40.6588C29.94 41.1907 29.672 41.785 29.1403 41.9861C28.6086 42.1873 28.0145 41.9192 27.8134 41.3873L15.9029 9.88736L3.99234 41.3873C3.79124 41.9192 3.19717 42.1873 2.66545 41.9861C2.13374 41.785 1.86573 41.1907 2.06684 40.6588L14.9401 6.61266C15.0915 6.21221 15.4749 5.94728 15.9029 5.94728Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.74698 31.1387C5.74698 30.5701 6.20782 30.1091 6.77629 30.1091H25.0432C25.6117 30.1091 26.0725 30.5701 26.0725 31.1387C26.0725 31.7074 25.6117 32.1683 25.0432 32.1683H6.77629C6.20782 32.1683 5.74698 31.7074 5.74698 31.1387Z"
  }));
});
FontSizeIcon.displayName = 'FontSizeIcon';
FontSizeIcon.defaultProps = {
  'aria-label': 'FontSize'
};
export default FontSizeIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/FontSizeIcon/index.js
// module id = 1854
// module chunks = 12